var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1688 146",
    style: {
      enableBackground: "new 0 0 1688 146"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#832729;}\n\t.st1{fill:#84292B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Line_Design"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14194",
    transform: "translate(-5 -41.068)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_294",
    className: "st0",
    x1: 27,
    y1: 114.5,
    x2: 783,
    y2: 114.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_295",
    className: "st0",
    x1: 915,
    y1: 114.5,
    x2: 1671,
    y2: 114.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    className: "st1",
    d: "M895.7,105.8c-5.4,0-10.8,1.3-15.6,3.7c-1.8,0.8-3.5,1.8-5.2,2.7c-0.8,0.4-1.3,1.3-1.2,2.2 c0.1,2.2-0.9,4.3-2.7,5.7c-2.3,2.1-5.3,3.2-8.4,3.1c-1.3-0.1-2.5-0.4-3.7-0.9c-0.5-0.2-1.1-0.3-1.6-0.1c-3.3,1.4-6.8,2.4-10.4,2.9 c-5,0.6-9.9,0.5-14.6-1.6c-2-0.8-3.7-2.1-5.1-3.8c-0.6-0.7-0.9-0.8-1.7-0.3c-4.1,2.5-8.7,4.3-13.4,5.2c-5.5,1-11,1.3-16.3-0.9 c-3.9-1.6-6.8-4.1-8.1-8.2c-0.7-2.1-1.1-4.3-0.1-6.4c1.1-2.4,3-4.2,5.5-5.1c4.6-1.9,9.2-2,13.6,0.7c1.6,1.1,2.9,2.6,3.7,4.4 c0.1,0.2,0.1,0.4-0.1,0.6c0,0-0.1,0-0.1,0.1c-0.2,0.2-0.5,0.2-0.7,0c-0.1-0.1-0.2-0.2-0.2-0.3c-1.4-2.9-4.1-5-7.3-5.4 c-3.8-0.8-7.7,0.1-10.8,2.5c-3.2,2.2-4,6.7-1.8,9.9c0.2,0.3,0.5,0.6,0.8,0.9c2,2.3,4.8,3.7,7.8,4.2c4.7,0.6,9.4,0.3,13.9-1.1 c3.9-1.1,7.6-2.8,11-4.9c1.3-0.8,1.5-1.3,1.2-2.8c-1.1-5.3,2.3-9.1,6.8-9.9c3.2-0.6,6.4,0.1,9.1,1.8c0.9,0.6,2.1,0.8,3.1,0.3 c4.5-1.7,9.3-2.4,14.1-2c4.1,0.3,8,1.1,11.5,3.5c0.7,0.5,1.4,1.1,2.1,1.7c0.5,0.6,1.3,0.7,1.9,0.2c2.4-1.3,4.8-2.4,7.3-3.3 c5.4-2,11.3-2.6,17-1.8c3.8,0.4,7.3,1.9,10.3,4.3c2.3,1.7,3.6,4.5,3.6,7.3c-0.1,1.8-0.9,3.5-2.2,4.8c-1.8,2-4.3,3.2-7,3.6 c-2.4,0.3-4.8-0.2-6.8-1.3c-0.4-0.2-0.4-0.5-0.2-0.9c0.2-0.3,0.5-0.4,0.8-0.2c1.7,1.2,3.9,1.7,5.9,1.3c2.4-0.3,4.7-1.4,6.5-3.1 c2.6-2.5,2.6-6.6,0.1-9.2c-0.2-0.2-0.5-0.5-0.8-0.7c-2.2-1.6-4.8-2.6-7.5-2.9C898.5,105.9,897.1,105.8,895.7,105.8L895.7,105.8z  M828.2,118.1c1.3,1.4,3,2.3,4.8,2.9c3.1,0.8,6.3,1.1,9.4,0.7c3.7-0.4,7.3-1.3,10.7-2.7c0.7-0.3,0.7-0.3,0.2-0.8 c-0.8-0.8-1.5-1.6-2.3-2.4c-2-2.1-3.9-4.2-6-6c-0.5-0.5-1.3-0.6-2-0.2C837.9,111.9,833.1,115.2,828.2,118.1z M845.5,108.6 c3,2.7,5.7,5.6,8.4,8.5c1,1,1.2,1.1,2.5,0.4c4.5-2.3,8.9-5,13.2-7.5c0.9-0.5,0.9-0.5,0-1.2c-1.9-1.3-4.1-2.2-6.4-2.5 c-4-0.6-8-0.5-11.9,0.3C849.3,106.9,847.3,107.6,845.5,108.6L845.5,108.6z M840.1,106c-0.1-0.1-0.1-0.1-0.1-0.1 c-2.6-1.8-5.9-2.6-9-2c-3.8,0.5-6.5,4.1-6,7.9c0,0.3,0.1,0.6,0.2,0.9c0.3,1.3,0.4,1.3,1.5,0.6c3.6-2.1,7.2-4.3,11-6.1 C838.5,106.8,839.3,106.4,840.1,106z M859.4,121.4c0.4,0.2,0.7,0.3,0.9,0.4c4,1,8.2-0.3,10.9-3.4c1.1-1.3,1.6-2.9,1.5-4.6 C868.3,116.3,864.1,119,859.4,121.4L859.4,121.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.a76606df6009db4a08778062cea8df62.svg";
export { ForwardRef as ReactComponent };